import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { Helmet } from "react-helmet"
// Components
import Navbar from "../../components/Navbar/Navbar"
import Footer from "../../components/Footer/Footer"
// Data
import { publicRequest } from "../../requestMethods"
// Styles
import {
   Container,
   Wrapper,
   Title,
   Text,
   RegionNote,
   RegionText,
   RegionLogo,
} from "./Legal.styles"
import logoRegion from "../../images/region-bfc.jpg"

const Legal = () => {
   const language = useSelector((state) => state.environment.language)
   const { t } = useTranslation()
   const [pageContent, setPageContent] = useState([{}])
   const [text, setText] = useState("")

   useEffect(() => {
      const getContent = async () => {
         const res = await publicRequest.get("page-contents")
         setPageContent(res.data.filter((item) => item.page === "cgv")[0])
         language === "fr"
            ? setText(res.data.filter((item) => item.page === "cgv")[0].textFr)
            : setText(res.data.filter((item) => item.page === "cgv")[0].textEn)
      }
      getContent()
   }, [setPageContent, setText, language])

   return (
      <>
         <Helmet>
            <title>{t("legalPage.meta.meta_title")}</title>
            <meta name="robots" content="noindex, nofollow" />
         </Helmet>
         <Container>
            <Navbar />
            <Wrapper>
               <Title>
                  {language === "fr"
                     ? pageContent?.titleFr
                     : pageContent?.titleEn}
               </Title>
               <RegionNote>
                  <RegionText>{t("legalPage.text.t1")}</RegionText>
                  <RegionLogo src={logoRegion} />
               </RegionNote>
               <Text
                  dangerouslySetInnerHTML={{
                     __html: text
                        ?.replace(/\n/g, "<br />")
                        .replace(
                           /(https?:\/\/[^\s<>"']+)/g,
                           '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
                        ),
                  }}
               />
            </Wrapper>
            <Footer />
         </Container>
      </>
   )
}

export default Legal
